/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import 'lib-flexible/flexible.js';
import Vue from 'vue';
import AlertPlugin from "vux/src/plugins/alert/index.js" // this line is trasformed by vux-loader
import ToastPlugin from "vux/src/plugins/toast/index.js" // this line is trasformed by vux-loader
import DatetimePlugin from "vux/src/plugins/datetime/index.js" // this line is trasformed by vux-loader
import ConfirmPlugin from "vux/src/plugins/confirm/index.js" // this line is trasformed by vux-loader
import App from './App';
import router from './router';
import store from './store'; // import './styles/font/iconfont.css';

Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(DatetimePlugin);
Vue.use(ConfirmPlugin);

if (process.env.VUE_APP_ENV !== 'pro') {
  // eslint-disable-next-line no-new
  new (require('vconsole'))();
}

Vue.config.productionTip = false;

var errorHandler = function _(e, vm) {
  if (process.env.VUE_APP_ENV !== 'pro') {
    // eslint-disable-next-line no-console
    console.log(e);
  }

  if (e instanceof window.DOMException) {
    return;
  }

  vm.$vux.toast.show({
    type: 'text',
    width: 'auto',
    text: e.message
  });
};

Vue.config.errorHandler = errorHandler;

Vue.prototype.$throw = function _(error) {
  return errorHandler(error, this);
};

document.body.addEventListener('touchstart', function () {});
/* eslint-disable no-new */

export default new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});